import { useContext } from 'react';
import { TranslateContext } from '../providers/TranslateProvider';
function useTranslate() {
    return useContext(TranslateContext);
}
export default useTranslate;
